import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {getBrowserLanguage, getLanguageByCode} from "wipi-common/src/lib/i18n";
import {LOG_EVENTS} from "wipi-common/src/lib/logging/events";
import LOG from "wipi-common/src/lib/logging/logger";

export class ListElement extends Component {

    chooseLanguage = (e) => {
        e.stopPropagation()
        const li = e.target.closest("li[data-language]")
        const languageCode = li?.dataset.language
        const language = getLanguageByCode(languageCode)

        if (!language) {
            console.error("Language not found for code:", languageCode)
            return
        }
        const context = {
            "deviceLanguage": getBrowserLanguage(),
            "currentLanguage": this.props.selectedLanguage,
            "selectedLanguage": language.value,
            "wasLanguageChanged": true
        }
        LOG.logInfo(LOG_EVENTS.CE_LANGUAGE_SELECTION, undefined, undefined, context)
        this.props.changeLanguage(e, language)
    }

    render() {
        let className = ""
        if (this.props.index !== this.props.languageCount - 1) {
            className = "border-bottom"
        }
        return <li className={className + " dropdown-item"} data-language={this.props.element.value}>
            <button className="button-no-style w-100 h-100 border-0 bg-transparent text-start"
                    tabIndex="0" aria-label={this.props.element.title}
                    onClick={this.chooseLanguage}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            this.chooseLanguage(e);
                        }
                    }}
            >
                <p>{this.props.element.title}</p>
                {this.props.element.value === this.props.selectedLanguage ?
                    <svg className="float-end" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path id="Vector 59" d="M1 9.10326L5.95652 15L15 1" stroke="#FD4646" strokeWidth="2"/>
                    </svg>
                    : ""}
            </button>
        </li>
    }
}

ListElement.propTypes = {
    changeLanguage: PropTypes.func.isRequired,
    selectedLanguage: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    languageCount: PropTypes.number.isRequired,
    element: PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
    }).isRequired
}

export default ListElement